import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	copyIcon: {
		id: 'eoc.heartbeats.name-input.copy-button.no-translate',
		defaultMessage: 'Copy heartbeat name',
		description: 'Icon label inside button.',
	},
	copy: {
		id: `eoc.heartbeats.name-input.copy.no-translate`,
		defaultMessage: 'Copy',
		description: "The text will be displayed at the copy button's tooltip",
	},
	copied: {
		id: `eoc.heartbeats.name-input.copied.no-translate`,
		defaultMessage: 'Copied',
		description: "The text will be displayed at the copy button's tooltip",
	},
});

export default messages;
